/**
 * Функция для создания ссылок на прогулку по каждому ближайшему времени
 * @returns гипертекстовая ссылка
 */
export default function makeHrefToBuyTicketsForm(
  tripKey: string,
  alias: string,
  pageLocationHost: string
): string {
  return `buy?id=${tripKey}&utm_source=${pageLocationHost}&utm_medium=nearcruisepreview&utm_campaign=${alias}&utm_content=${tripKey}`;
}
